import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import QueuedOrder from '../componets/QueuedOrders';

export default function Chef({orders, setOrders}) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        '& .MuiTable-root': { backgroundColor: '#fff2d7' }
      }}
    >
      <Table aria-label="collapsible table">
        <TableHead sx={{
          '& .MuiTableCell-root': { color: '#fff2d7' },
          '& .MuiTableRow-root': { backgroundColor: '#16314c' }
        }} >
          <TableRow>
            <TableCell>Order Status</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Time</TableCell>
            <TableCell>Order N.</TableCell>
            <TableCell>Tot</TableCell>
            <TableCell align="right">Order details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders !== null ? orders.map((value, index) => (
            <QueuedOrder key={value.orderCode} rowIndex={index} order={value} setOrders={setOrders} />
          )) : "Loading..."}
        </TableBody>
      </Table>
    </TableContainer>
  );
}